module.exports = __webpack_public_path__ + "img/2-3.ff4ef16f.svg";